import { call, put, takeEvery, getContext } from "redux-saga/effects";

import {
  completeTwoFactorsTypes,
  getQrCodeTypes,
  twoFactorsEnableTypes,
  disalbeTwoFactorsTypes,
} from "./actionTypes";
import {
  getQrFailure,
  getQrSuccess,
  completeTwoFactorsSuccess,
  completeTwoFactorsFailure,
  enableTwoFactorsSuccess,
  enableTwoFactorsFailure,
  disableTwoFactorsSuccess,
  disableTwoFactorsFailure,
} from "./actions";
import { setProfile } from "../profile/actions";
import { CONTEXT } from "@const/redux";
import { localstorageKeys } from "@const/store";
import storageService from "../../services/StorageService";

const getQrAsync = async ({ TwoFactorsService }) => {
  if (!TwoFactorsService) {
    console.log("Required services does not exist");

    return null;
  }

  return TwoFactorsService.toggle2FA({
    isEnabled: true,
  });
};

function* getQrCode() {
  try {
    const { TwoFactorsService } = yield getContext(CONTEXT.SERVICES);

    const {
      data: { qr, secret },
    } = yield call(getQrAsync, {
      TwoFactorsService,
    });

    yield put(getQrSuccess({ qr, ...secret }));
  } catch ({ error }) {
    yield put(getQrFailure({ error }));
  }
}

const enableTwoFactorsAsync = async ({ TwoFactorsService, base32, token }) => {
  if (!TwoFactorsService) {
    console.log("Required services does not exist");

    return null;
  }

  return TwoFactorsService.verifyEnable2FA({
    base32,
    token,
  });
};

function* enableTwoFactors({ payload: { base32, token } }) {
  try {
    const { TwoFactorsService } = yield getContext(CONTEXT.SERVICES);

    yield call(enableTwoFactorsAsync, {
      TwoFactorsService,
      base32,
      token,
    });

    yield put(setProfile({ is2FAEnabled: true }));
    yield put(enableTwoFactorsSuccess());
  } catch ({ error }) {
    yield put(enableTwoFactorsFailure(error));
  }
}

const disableTwoFactorsAsync = ({ TwoFactorsService, twoFactorCode }) => {
  if (!TwoFactorsService) {
    console.log("Required services does not exist");

    return null;
  }

  return TwoFactorsService.toggle2FA({
    isEnabled: false,
    twoFactorCode,
  });
};

function* disableTwoFactors({ payload: { twoFactorCode } }) {
  try {
    const { TwoFactorsService } = yield getContext(CONTEXT.SERVICES);

    yield call(disableTwoFactorsAsync, { TwoFactorsService, twoFactorCode });

    yield put(setProfile({ is2FAEnabled: false }));
    yield put(disableTwoFactorsSuccess());
  } catch ({ error }) {
    yield put(disableTwoFactorsFailure(error));
  }
}

const completeTwoFactorsAsync = ({ TwoFactorsService, token }) => {
  if (!TwoFactorsService) {
    console.log("Required services does not exist");

    return null;
  }

  return TwoFactorsService.complete2FA({
    token,
  });
};

function* completeTwoFactors({ payload: { token } }) {
  try {
    const { TwoFactorsService, StorageService } = yield getContext(
      CONTEXT.SERVICES,
    );

    const authSession = StorageService.get(localstorageKeys.authSession, {});
    StorageService.set(localstorageKeys.session, authSession);

    const { data } = yield call(completeTwoFactorsAsync, {
      TwoFactorsService,
      token,
    });
    const { user, session } = data;
    StorageService.set(localstorageKeys.session, session);
    StorageService.remove(localstorageKeys.authSession, null);
    yield put(setProfile(user));
    storageService.set(
      localstorageKeys.tourFinished,
      user.isProfileTourCompleted,
    );
    yield put(completeTwoFactorsSuccess());
  } catch ({ error }) {
    const { StorageService } = yield getContext(CONTEXT.SERVICES);
    StorageService.set(localstorageKeys.session, "");
    yield put(completeTwoFactorsFailure(error));
  }
}

export function* watchGetQrCode() {
  yield takeEvery(getQrCodeTypes.request, getQrCode);
}

export function* watchEnableTwoFactors() {
  yield takeEvery(twoFactorsEnableTypes.request, enableTwoFactors);
}

export function* watchDisableTwoFactors() {
  yield takeEvery(disalbeTwoFactorsTypes.request, disableTwoFactors);
}

export function* watchCompleteTwoFactors() {
  yield takeEvery(completeTwoFactorsTypes.request, completeTwoFactors);
}
